// extracted by mini-css-extract-plugin
module.exports = {"link":"PendingPayment_link_Hu-FH"};